import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { AddToColorCollectionContent } from "./add-to-color-collection-content";

function AddToColorCollectionDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent>
        <AddToColorCollectionContent
          closeClickHandler={() => updateIsModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}

export function AddToColorCollectionModal() {
  const isModalOpen = useAddToColorCollectionModalStore(
    (state) => state.isModalOpen
  );
  const updateIsModalOpen = useAddToColorCollectionModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <>
      {isModalOpen && (
        <AddToColorCollectionDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
